import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children, dark = false }) {
  return (
    <div
      className={`text-[11px] font-bold uppercase tracking-[0.22em] font-body ${
        dark ? "text-emerald-400" : "text-emerald-800"
      }`}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ children, dark = false, className = "" }) {
  return (
    <h2
      className={`mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.02] ${
        dark ? "text-white" : "text-stone-950"
      } ${className}`}
    >
      {children}
    </h2>
  );
}

export function Bullet({ icon: Icon, title, desc, dark = false }) {
  return (
    <li className="flex gap-4">
      <div
        className={`mt-0.5 h-10 w-10 shrink-0 rounded-lg flex items-center justify-center ${
          dark ? "bg-emerald-500/15 text-emerald-300" : "bg-emerald-100 text-emerald-800"
        }`}
      >
        <Icon className="h-5 w-5" />
      </div>
      <div>
        <div className={`font-display font-bold text-base ${dark ? "text-white" : "text-stone-950"}`}>
          {title}
        </div>
        <p className={`mt-1 font-body text-sm leading-relaxed ${dark ? "text-stone-400" : "text-stone-600"}`}>
          {desc}
        </p>
      </div>
    </li>
  );
}
